module.exports = __webpack_public_path__ + "Roboto-Medium.c54f2a3ee42d2a58d82f.ttf";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Medium.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Medium.ttf
// module chunks = 5